/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliAttendanceDto } from '../../models/amoxcalli-attendance-dto';

export interface ApiAttendanceGet$Json$Params {
  groupId?: string;
  fecha?: string;
}

export function apiAttendanceGet$Json(http: HttpClient, rootUrl: string, params?: ApiAttendanceGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliAttendanceDto>>> {
  const rb = new RequestBuilder(rootUrl, apiAttendanceGet$Json.PATH, 'get');
  if (params) {
    rb.query('groupId', params.groupId, {});
    rb.query('fecha', params.fecha, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliAttendanceDto>>;
    })
  );
}

apiAttendanceGet$Json.PATH = '/api/attendance';
